import axios from "axios";
import store from "./store";

const http = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
  timeout: 30000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    locale: "pt_BR"
  }
});

let isHandlingExpiredToken = false;

const getResponseMessage = response => {
  return response && response.data ? response.data.message : "";
};

const isExpiredTokenResponse = response => {
  return getResponseMessage(response) === "EXPIRED_TOKEN";
};

const logoutExpiredSession = () => {
  if (isHandlingExpiredToken) return;

  isHandlingExpiredToken = true;

  store.dispatch("clearAccountData");
  store.dispatch("clearStores");
  store.dispatch("clearPurchases");
  store.dispatch("setStoreBeingManaged", null);
  store.dispatch("setLockerBeingManaged", null);
  store.dispatch("logout");

  if (window && window.location && window.location.pathname !== "/") {
    window.location.replace("/");
  }
};

http.interceptors.request.use(
  config => {
    // add authorization token if logged in unless explicitly skipped
    if (!config.skipAuthHeader && store.getters.isAuthenticated) {
      config.headers.common["Authorization"] =
        "Bearer " + store.getters.sessionToken;
    } else if (config.skipAuthHeader) {
      if (config.headers && config.headers.common) {
        delete config.headers.common["Authorization"];
      }
      if (config.headers) {
        delete config.headers["Authorization"];
      }
    }

    // add timezone unless explicitly skipped
    if (!config.skipTimezoneHeader) {
      config.headers.common["timezone"] = !isNaN(
        store.getters.preferences.timezone
      )
        ? store.getters.preferences.timezone
        : -3;
    }

    // add language preference unless explicitly skipped
    if (!config.skipLocaleHeader && store.getters.locale) {
      config.headers["locale"] = store.getters.locale;
    } else if (config.skipLocaleHeader) {
      if (config.headers && config.headers.common) {
        delete config.headers.common["locale"];
      }
      if (config.headers) {
        delete config.headers["locale"];
      }
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  response => {
    if (isExpiredTokenResponse(response)) {
      logoutExpiredSession();
    }

    return response;
  },
  error => {
    if (error && isExpiredTokenResponse(error.response)) {
      logoutExpiredSession();
    }

    return Promise.reject(error);
  }
);

export default http;
